import { render, staticRenderFns } from "./Metaphors.vue?vue&type=template&id=1ffaa734&scoped=true&"
import script from "./Metaphors.vue?vue&type=script&lang=js&"
export * from "./Metaphors.vue?vue&type=script&lang=js&"
import style0 from "./Metaphors.vue?vue&type=style&index=0&id=1ffaa734&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffaa734",
  null
  
)

export default component.exports